import(/* webpackMode: "eager" */ "/app/app/(seo)/terms/page.tsx");
